module.exports = __webpack_public_path__ + "static/media/mail.306c4151.svg";